import {useState} from "react";
import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";

const BankTransferAPI = () => {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();
    const [GetBankTransferData, setGetBankTransferData] = useState([]);
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [bankTransfersLoading, setBankTransfersLoading] = useState(true);
    const [names, setNames] = useState(null);
    const [namesLoading, setNamesLoading] = useState(true);

    async function GetBankTransfersList(pageNb, dateFrom, DateTo) {
        await MerchantPortalAxios.post(
            `/v1/BankTransfer/GetBankTransfer`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                page: pageNb,
                pageSize: 10,
                DateFrom: dateFrom,
                DateTo: DateTo
            }
        ).then((res) => {
            setGetBankTransferData(res.data.Payload.BankTransfers);
            if (res.data.Payload.BankTransfers?.length===0){
                setTotalNbOfPage(0);
                setTotalCount(0);
            }else{
                setTotalNbOfPage(res.data.Payload.BankTransfers[0].TotalPages);
                setTotalCount(res.data.Payload.BankTransfers[0].TotalCount);
            }

            if (res.data.Payload.TemplateURL)
                sessionStorage.setItem("BankTransferTemplate", res.data.Payload.TemplateURL);

            setBankTransfersLoading(false);
        });
    }

    const PushBankTransfer = async (payload) => {
        if (payload.ReasonFile) {
            const fileData = payload.ReasonFile.split(',')[1];
            const mimeType = payload.ReasonFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            const file = new File([byteArrays], payload.ReasonFileName, {type: mimeType});
            payload.ReasonFile = file;
        }

        const response = await MerchantPortalAxios1.post('/v1/BankTransfer/PushBankTransfer', payload);
        return response.data;

    };

    const PushBulkBankTransfer = async (payload) => {
        if (payload.formFile) {
            const fileData = payload.formFile.split(',')[1];
            const mimeType = payload.formFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            const file = new File([byteArrays], payload.ReasonFileName, {type: mimeType});
            payload.formFile = file;
        }
        const {ReasonFileName, ...newPayload} = payload

        const response = await MerchantPortalAxios1.post('/v1/BankTransfer/PushBulkBankTransfer', newPayload);
        return response.data;

    };

    async function GetBeneficiaryNames(pageNb, dateFrom, DateTo) {
        await MerchantPortalAxios.post(
            `/v1/BankTransfer/GetBeneficiaryNames`,
            {
                SessionID: sessionStorage.getItem("SessionID"),
                page: pageNb,
                pageSize: 10,
                DateFrom: dateFrom,
                DateTo: DateTo
            }
        ).then((res) => {
            setNames(res.data.Payload.Names);
            setNamesLoading(false);
        });
    }

    return {
        GetBankTransfersList,
        PushBankTransfer,
        PushBulkBankTransfer,
        GetBeneficiaryNames,
        GetBankTransferData,
        totalNbOfPage,
        totalCount,
        bankTransfersLoading,
        names,
        namesLoading
    };
};

export default BankTransferAPI;
